import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'

interface Props {
  fullWidth?: boolean
}

const formFieldStyles = css({
  maxWidth: '315px',
  width: '100%',
})

const fullWidthStyles = css({
  maxWidth: 'none',
})

export const MerchandisingFormField: FunctionComponent<Props> = ({ children, fullWidth }) => (
  <div css={[formFieldStyles, fullWidth && fullWidthStyles]}>{children}</div>
)
